import { z } from "zod";

export const API_BASE = "/api/v1";

/** Standard error shape returned by every endpoint. */
export interface ApiError {
  error: string;
  message?: string;
  details?: unknown;
}

export interface Page<T> {
  items: T[];
  nextCursor: string | null;
  total?: number;
}

export const PaginationQuery = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type PaginationQuery = z.infer<typeof PaginationQuery>;

export const IdParam = z.object({ id: z.string().uuid() });

// btoa/atob exist in browsers, Workers and Node 16+; encode UTF-8 safely first.
function toBase64Url(s: string): string {
  const bytes = new TextEncoder().encode(s);
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function fromBase64Url(s: string): string {
  const b64 = s.replace(/-/g, "+").replace(/_/g, "/");
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new TextDecoder().decode(bytes);
}

/** Keyset cursor: base64url of a JSON array [sortValue, id]. */
export function encodeCursor(parts: unknown[]): string {
  return toBase64Url(JSON.stringify(parts));
}
export function decodeCursor(cursor: string): unknown[] | null {
  try {
    const parts = JSON.parse(fromBase64Url(cursor));
    return Array.isArray(parts) ? parts : null;
  } catch {
    return null;
  }
}
